import { CommonModule } from '@angular/common';
import { Component, HostListener, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ApplicationService } from 'app/services/application.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-select-branch-popup',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatIconModule,
        TranslateModule,
    ],
    templateUrl: './select-branch-popup.component.html',
})
export class SelectBranchPopupComponent {
    branchDetails;
    initialBranchesList;
    searchInput = '';
    selectBranchClicked = false;
    selectedBranchId;
    selectedBranchDetails;
    selectedBranchIdArr = [];
    selectedOfficerIdArr: any[];
    fiId: any;
    selectedBranchName: any;
    selectedBranchCode: any;
    selectedBranchEmail: any;
    selectedBranchNameArr = [];
    selectedBranchEmailArr = [];
    initialSelectedBranchId: any;
    initialSelectedOfficerId: any;
    branch: string = '';
    stateOptions: [] = [];
    selectedState: string = '';
    isStateDropdownOpen: boolean = false;
    branchSuggestion: [];
    selectedOfficerId: number;
    selectedOfficerName: string;
    selectedOfficerEmail: string;
    selectedFiProd: string;
    selectOfficer: string;
    selectBranch: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<SelectBranchPopupComponent>,
        private applicationService: ApplicationService,
        private translate: TranslateService,
        private toastr: ToastrService
    ) {}

    @HostListener('document:click', ['$event'])
    closeDropdown(event: MouseEvent): void {
        const target = event.target as HTMLElement;
        const dropdown = document.getElementById('stateDropdown');
        const branchSuggestionDropdown =
            document.getElementById('branchSuggestion');
        const searchInput = document.getElementById('searchInput');

        if (searchInput && searchInput.contains(target)) {
            return;
        }

        if (
            dropdown &&
            !dropdown.contains(target) &&
            this.isStateDropdownOpen
        ) {
            this.isStateDropdownOpen = false;
        }

        if (
            branchSuggestionDropdown &&
            !branchSuggestionDropdown.contains(target) &&
            this.branchSuggestion.length > 0
        ) {
            this.branchSuggestion = [];
        }
    }

    ngOnInit() {
        this.branchDetails = this.data.productDetails.branchListing;
        this.initialBranchesList = this.data.productDetails.branchListing;
        this.branch = this.data.branch;
        if (this.data.selectedProducts.length > 0) {
            let result;
            this.data.productDetails.branchListing.forEach((element) => {
                if (
                    (result = this.data.selectedProducts.find(
                        (element2) =>
                            element2.branchId == element.branchId &&
                            element2.branchName == element.branchName
                    ))
                ) {
                    this.selectedBranchIdArr.push(result.branchId);
                    this.selectedBranchNameArr.push(result.branchName);
                    this.selectedBranchEmailArr.push(result.branchEmail);
                }
            });
            this.selectedBranchId = this.selectedBranchIdArr[0]
                ? this.selectedBranchIdArr[0]
                : this.data.branchId;
            this.selectedBranchName = this.selectedBranchNameArr[0]
                ? this.selectedBranchNameArr[0]
                : this.data.branch;
            this.selectedBranchEmail = this.selectedBranchEmailArr[0]
                ? this.selectedBranchEmailArr[0]
                : this.data.selectedBranchEmail;

            this.selectedOfficerId = this.data.selectedBranchOfficerId;
            let officerObj = {
                officerId: this.data?.selectedBranchOfficerId,
                officerName: this.data?.selectedBranchOfficerName,
                officerEmail: this.data?.selectedBranchOfficerEmail,
            };
            this.selectedBranchDetails = {
                ...officerObj,
            };
        } else {
            this.selectedBranchId = this.selectedBranchIdArr[0]
                ? this.selectedBranchIdArr[0]
                : this.data.branchId;
            this.selectedBranchName = this.selectedBranchNameArr[0]
                ? this.selectedBranchNameArr[0]
                : this.data.branch;
            this.selectedBranchEmail = this.selectedBranchEmailArr[0]
                ? this.selectedBranchEmailArr[0]
                : this.data.selectedBranchEmail;

            let officerObj = {
                officerId: this.data?.selectedBranchOfficerId,
                officerName: this.data?.selectedBranchOfficerName,
                officerEmail: this.data?.selectedBranchOfficerEmail,
            };
            this.selectedBranchDetails = {
                ...officerObj,
            };
            this.selectedOfficerId = this.data?.selectedBranchOfficerId;
            this.selectedBranchDetails.officerName =
                this.data?.selectedBranchOfficerName;
            this.selectedBranchDetails.officerEmail =
                this.data?.selectedBranchOfficerEmail;
        }
        this.initialSelectedBranchId = this.selectedBranchId;
        this.initialSelectedOfficerId = this.selectedOfficerId;
        this.fiId = this.data?.productDetails.fiId;
        this.getStatesList();
        this.getTranslations();
    }

    getTranslations() {
        this.translate
            .get('SELECT_BRANCH.PLEASE_SELECT_BRANCH_TO_CONTINUE')
            .subscribe((data: string) => {
                this.selectBranch = data;
            });

        this.translate
            .get('SELECT_BRANCH.PLEASE_SELECT_OFFICER_TO_CONTINUE')
            .subscribe((data: string) => {
                this.selectOfficer = data;
            });
    }

    onSearchBranch(searchInput: string) {
        if (!searchInput) {
            this.branchDetails = this.initialBranchesList;
            return;
        }

        //search by city or postcode
        const filteredBranches = this.filterBranches(searchInput);
        this.branchDetails = filteredBranches;
        this.branchSuggestion = filteredBranches;
        this.isStateDropdownOpen = false;
        this.selectedState = null;
    }

    filterBranches(searchText: string) {
        return this.initialBranchesList.filter(
            (branch) =>
                branch.city.toLowerCase().includes(searchText.toLowerCase()) ||
                branch.ptc.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    onSelectBranch(event, branchDetails) {
        this.selectedBranchDetails = {
            branchName: branchDetails.branchName,
            fiId: this.fiId,
            branchId: branchDetails.branchId,
            branchEmail: branchDetails.email,
            branchCode: branchDetails?.branchCode,
        };
        this.selectedBranchId = branchDetails.branchId;
        this.selectedFiProd = branchDetails.fiProd;
        this.selectBranchClicked = true;
        this.branch = branchDetails.branchName;
        this.selectedOfficerId = null;
    }

    onOfficerSelect(officer: any) {
        if (officer) {
            this.selectedBranchDetails.officerName = officer?.officerName;
            this.selectedBranchDetails.officerEmail = officer?.officerEmail;
            this.selectedBranchDetails.officerId = officer?.officerId;
            this.selectedBranchDetails.officerUsername =
                officer?.officerUserName;
            this.selectedOfficerId = officer?.officerId;
        }
    }

    selectAutoSuggestion(branch: any) {
        this.searchInput = `${branch.ptc}, ${branch.city}`;
        this.branchDetails = this.initialBranchesList.filter(
            (b) =>
                b.city.toLowerCase() === branch.city.toLowerCase() &&
                b.ptc.toLowerCase() === branch.ptc.toLowerCase()
        );
        this.branchSuggestion = [];
    }

    highlightText(text: string, search: string): string {
        if (!search) return text;
        const pattern = search
            .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
            .split(' ')
            .filter((t) => t.length > 0)
            .join('|');
        const regex = new RegExp(pattern, 'gi');
        return text.replace(
            regex,
            (match) => `<span class="tw-text-[#003A70]">${match}</span>`
        );
    }

    clearSearchInput() {
        this.searchInput = '';
        this.branchDetails = this.initialBranchesList;
    }

    onSubmit() {
        if (!this.selectedBranchId) {
            this.toastr.error(this.selectBranch);
            return;
        }
        if (
            this.selectedFiProd === 'IFBU' &&
            !(
                this.selectedBranchDetails?.officerName &&
                this.selectedBranchDetails?.officerEmail
            )
        ) {
            this.toastr.error(this.selectOfficer);
            return;
        }
        if (this.selectBranchClicked == true) {
            if (
                this.initialSelectedBranchId &&
                this.selectedBranchId &&
                this.initialSelectedBranchId !== this.selectedBranchId
            ) {
                this.selectedBranchDetails['isBranchChanged'] = true;
                //remove products belonging to that branch if branch is changed
                let removeProductArr = [];
                let getRemoveProductArr = this.data.selectedProducts.filter(
                    (element) => {
                        if (element.branchId == this.initialSelectedBranchId) {
                            removeProductArr.push(element.prodCode);
                        }
                    }
                );
                let removeProdCode = removeProductArr;
                this.selectedBranchDetails['prodCode'] = removeProdCode;
            }
        } else {
            if (
                this.initialSelectedOfficerId &&
                this.selectedOfficerId &&
                this.initialSelectedOfficerId !== this.selectedOfficerId
            ) {
                this.selectedBranchDetails['isOfficerChanged'] = true;
            }
            this.selectedBranchDetails = {
                branchName: this.selectedBranchName,
                fiId: this.fiId,
                branchId: this.selectedBranchId,
                branchEmail: this.selectedBranchEmail,
                ...this.selectedBranchDetails,
            };
        }
        this.dialogRef.close({ data: this.selectedBranchDetails });
    }

    getStatesList() {
        this.applicationService.getStates().subscribe({
            next: (res) => {
                this.stateOptions = res.states;
            },
            error: (err) => {},
        });
    }

    onStateChange(event: Event): void {
        const selectedState = (event.target as HTMLSelectElement).value;
        this.branchDetails = selectedState
            ? this.initialBranchesList.filter(
                  (branch) => branch.state === selectedState
              )
            : this.initialBranchesList;
    }

    selectState(state: string): void {
        if (this.selectedState === state) {
            this.resetState();
        } else {
            this.selectedState = state;
            const customEvent = {
                target: { value: state },
            } as unknown as Event;
            this.onStateChange(customEvent);
        }
        this.isStateDropdownOpen = false;
        this.searchInput = '';
    }

    resetState(): void {
        this.selectedState = null;
        this.branchDetails = this.initialBranchesList;
        this.isStateDropdownOpen = false;
        this.searchInput = '';
    }

    toggleDropdown(event: MouseEvent) {
        event.stopPropagation();
        this.isStateDropdownOpen = !this.isStateDropdownOpen;
    }

    get showPreferredBranchMessage(): boolean {
        return this.branchDetails?.some((branch) => branch.officer?.length > 0);
    }

    onKeyPress(event: KeyboardEvent) {
        if (event.key === 'Enter' || event.key === 'Tab') {
            this.branchSuggestion = [];
            const searchInput = document.getElementById(
                'searchInput'
            ) as HTMLInputElement;
            if (searchInput) {
                searchInput.blur();
            }
        }
    }

    onFocusSearchInput() {
        if (this.searchInput) {
            this.branchSuggestion = this.filterBranches(this.searchInput);
        }
    }
}
